// src/RoomBookingIcon.tsx
import { jsx } from "react/jsx-runtime";
var RoomBookingIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.335 3.919 9.797.744C8.561-.122 6.661-.075 5.471.847l-3.947 3.08C.736 4.541.113 5.801.113 6.794v5.436a3.65 3.65 0 0 0 3.641 3.648h8.493a3.64 3.64 0 0 0 3.64-3.64V6.897c0-1.063-.685-2.371-1.552-2.978m-5.744 8.808a.596.596 0 0 1-.591.591.596.596 0 0 1-.591-.591v-2.364c0-.323.268-.591.591-.591s.591.268.591.591z",
        fill: "#fff"
      }
    )
  }
);
var RoomBookingIcon_default = RoomBookingIcon;

export {
  RoomBookingIcon_default
};
